module.exports = __webpack_public_path__ + "img/fen1.418d5159.png";